import { Injectable } from '@angular/core';
import { OverlayHandle, OverlayRole, OverlayService } from './overlay.service';

export interface MpToastButton {
	text?: string;
	icon?: string;
	role?: string;
	handler?: () => boolean | void;
}

export interface MpToastOptions {
	message?: string;
	duration?: number;
	position?: 'top' | 'bottom' | 'middle';
	color?: string;
	cssClass?: string | string[];
	buttons?: MpToastButton[];
}

/** Drop-in do ToastController do @ionic/angular (mensagem flutuante, auto-dismiss, sem backdrop). */
@Injectable({ providedIn: 'root' })
export class MpToastController {
	constructor(private overlay: OverlayService) {}

	create(opts: MpToastOptions = {}): Promise<OverlayHandle> {
		const el = document.createElement('div');
		el.className = 'mp-toast';
		if (opts.color) el.classList.add(`mp-toast--${opts.color}`);

		const content = document.createElement('div');
		content.className = 'mp-toast-content';
		content.innerHTML = opts.message ?? '';
		el.appendChild(content);

		const classes = Array.isArray(opts.cssClass) ? [...opts.cssClass] : opts.cssClass ? [opts.cssClass] : [];
		classes.push(`mp-toast-position--${opts.position || 'bottom'}`);

		const handle = this.overlay.create({
			kind: 'toast',
			element: el,
			cssClass: classes,
			backdropDismiss: false,
			showBackdrop: false,
			duration: opts.duration,
		});

		for (const btn of opts.buttons || []) {
			const b = document.createElement('button');
			b.type = 'button';
			b.className = 'mp-toast-button';
			b.textContent = btn.text || '';
			b.addEventListener('click', () => {
				const result = btn.handler ? btn.handler() : undefined;
				if (result === false) return;
				handle.dismiss(undefined, btn.role);
			});
			el.appendChild(b);
		}

		return Promise.resolve(handle);
	}

	dismiss(data?: any, role?: OverlayRole): Promise<boolean> {
		return this.overlay.dismissTop(data, role, 'toast');
	}

	getTop(): Promise<OverlayHandle | undefined> {
		return Promise.resolve(this.overlay.getTop('toast'));
	}
}
